import React, { useState } from "react";

// Iconos del menu CMMS. Trazos copiados tal cual de Tabler Icons (tablericons.com, version
// outline 3.31.0), con el mismo comportamiento que el resto de src/Icons: 16px, color al
// pasar el mouse y margen a la derecha para el menu.

const IconoTabler = ({ trazos, size = 16, stroke = 2, color = "currentColor", hoverColor = "#1890ff", marginRight = 8 }) => {
    const [isHovered, setIsHovered] = useState(false);
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke={isHovered ? hoverColor : color}
            strokeWidth={stroke}
            strokeLinecap="round"
            strokeLinejoin="round"
            style={{ transition: "stroke 0.5s ease", marginRight: `${marginRight}px`, marginBottom: "-3px" }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {trazos.map((d) => (
                <path key={d} d={d} />
            ))}
        </svg>
    );
};

const crear = (trazos) => (props) => <IconoTabler trazos={trazos} {...props} />;

// heart-rate-monitor: el modulo CMMS (equipo medico)
export const IconCMMS = crear([
    "M3 4m0 1a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v10a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1z",
    "M7 20h10",
    "M9 16v4",
    "M15 16v4",
    "M7 10h2l2 3l2 -6l1 3h3",
]);

// home: inicio del modulo (lo que hay que atender hoy)
export const IconInicioCMMS = crear(["M5 12l-2 0l9 -9l9 9l-2 0", "M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7", "M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"]);

// car: viajes de los ingenieros (C-LO-01)
export const IconViajesCMMS = crear([
    "M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
    "M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
    "M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5",
]);

// calendar-event: Agenda
export const IconAgendaCMMS = crear(["M4 5m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z", "M16 3l0 4", "M8 3l0 4", "M4 11l16 0", "M8 15h2v2h-2z"]);

// tool: Servicios (Ordenes de Servicio)
export const IconServiciosCMMS = crear(["M7 10h3v-3l-3.5 -3.5a6 6 0 0 1 8 8l6 6a2 2 0 0 1 -3 3l-6 -6a6 6 0 0 1 -8 -8l3.5 3.5"]);

// ticket: Tickets
export const IconTicketsCMMS = crear([
    "M15 5l0 2",
    "M15 11l0 2",
    "M15 17l0 2",
    "M5 5h14a2 2 0 0 1 2 2v3a2 2 0 0 0 0 4v3a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-3a2 2 0 0 0 0 -4v-3a2 2 0 0 1 2 -2",
]);

// file-certificate: Contratos
export const IconContratosCMMS = crear([
    "M14 3v4a1 1 0 0 0 1 1h4",
    "M5 8v-3a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2h-5",
    "M6 14m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0",
    "M4.5 17l-1.5 5l3 -1.5l3 1.5l-1.5 -5",
]);

// stethoscope: Activos (equipo medico de los clientes)
export const IconActivosCMMS = crear([
    "M6 4h-1a2 2 0 0 0 -2 2v3.5h0a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0 -2 -2h-1",
    "M8 15a6 6 0 1 0 12 0v-3",
    "M11 3v2",
    "M6 3v2",
    "M20 10m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0",
]);

// category: Tipos de Activo
export const IconTiposActivoCMMS = crear(["M4 4h6v6h-6z", "M14 4h6v6h-6z", "M4 14h6v6h-6z", "M17 17m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0"]);

// list-check: Rutinas
export const IconRutinasCMMS = crear(["M3.5 5.5l1.5 1.5l2.5 -2.5", "M3.5 11.5l1.5 1.5l2.5 -2.5", "M3.5 17.5l1.5 1.5l2.5 -2.5", "M11 6l9 0", "M11 12l9 0", "M11 18l9 0"]);

// report-analytics: Reportes del CMMS
// certificate: certificados de verificacion
export const IconCertificadosCMMS = crear([
    "M15 15m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0",
    "M13 17.5v4.5l2 -1.5l2 1.5v-4.5",
    "M10 19h-5a2 2 0 0 1 -2 -2v-10c0 -1.1 .9 -2 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -1 1.73",
    "M6 9l12 0",
    "M6 12l3 0",
    "M6 15l2 0",
]);

export const IconReportesCMMS = crear([
    "M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2",
    "M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z",
    "M9 17v-5",
    "M12 17v-1",
    "M15 17v-3",
]);

// adjustments: Configuracion del CMMS
export const IconConfiguracionCMMS = crear([
    "M4 10a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
    "M6 4v4",
    "M6 12v8",
    "M10 16a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
    "M12 4v10",
    "M12 18v2",
    "M16 7a2 2 0 1 0 4 0a2 2 0 0 0 -4 0",
    "M18 4v1",
    "M18 9v11",
]);
